// extracted by mini-css-extract-plugin
export var downloadLink = "DownloadLink-module--downloadLink--bQE3S";
export var downloadLink__fileType = "DownloadLink-module--downloadLink__fileType--TQkID";